import axios from "axios";

var suporte = null;
var erp = null;
var processos = null;
var gerencia = null;
var operacao = null;
var sistemas = null;
var labs = null;
var seguranca = null;
var atendimento = null;

const Suporte = async () => {
  if (suporte == null) {
    const resposta = await axios.get("_equipe/suporte.json");
    if (resposta.status !== 200) {
      throw new Error(resposta.data.exception.errorMessage);
    } else {
      suporte = resposta.data;
      return resposta.data.message ? resposta.data.message : resposta.data;
    }
  } else {
    return suporte;
  }
};

const ERP = async () => {
  if (erp == null) {
    const resposta = await axios.get("_equipe/erp.json");
    if (resposta.status !== 200) {
      throw new Error(resposta.data.exception.errorMessage);
    } else {
      erp = resposta.data;
      return resposta.data.message ? resposta.data.message : resposta.data;
    }
  } else {
    return erp;
  }
};

const ProcessosEProjetos = async () => {
  if (processos == null) {
    const resposta = await axios.get("_equipe/processos.json");
    if (resposta.status !== 200) {
      throw new Error(resposta.data.exception.errorMessage);
    } else {
      processos = resposta.data;
      return resposta.data.message ? resposta.data.message : resposta.data;
    }
  } else {
    return processos;
  }
};

const Gerencia = async () => {
  if (gerencia == null) {
    const resposta = await axios.get("_equipe/gerencia.json");
    if (resposta.status !== 200) {
      throw new Error(resposta.data.exception.errorMessage);
    } else {
      gerencia = resposta.data;
      return resposta.data.message ? resposta.data.message : resposta.data;
    }
  } else {
    return gerencia;
  }
};

const Labs = async () => {
  if (labs == null) {
    const resposta = await axios.get("_equipe/labs.json");
    if (resposta.status !== 200) {
      throw new Error(resposta.data.exception.errorMessage);
    } else {
      labs = resposta.data;
      return resposta.data.message ? resposta.data.message : resposta.data;
    }
  } else {
    return labs;
  }
};

const Operacao = async () => {
  if (operacao == null) {
    const resposta = await axios.get("_equipe/operacao.json");
    if (resposta.status !== 200) {
      throw new Error(resposta.data.exception.errorMessage);
    } else {
      operacao = resposta.data;
      return resposta.data.message ? resposta.data.message : resposta.data;
    }
  } else {
    return operacao;
  }
};

const Sistemas = async () => {
  if (sistemas == null) {
    const resposta = await axios.get("_equipe/sistemas.json");
    if (resposta.status !== 200) {
      throw new Error(resposta.data.exception.errorMessage);
    } else {
      sistemas = resposta.data;
      return resposta.data.message ? resposta.data.message : resposta.data;
    }
  } else {
    return sistemas;
  }
};

const Seguranca = async () => {
  if (seguranca == null) {
    const resposta = await axios.get("_equipe/seguranca.json");
    if (resposta.status !== 200) {
      throw new Error(resposta.data.exception.errorMessage);
    } else {
      seguranca = resposta.data;
      return resposta.data.message ? resposta.data.message : resposta.data;
    }
  } else {
    return seguranca;
  }
};

const Atendimento = async () => {
  if (atendimento == null) {
    const resposta = await axios.get("_equipe/atendimento.json");
    if (resposta.status !== 200) {
      throw new Error(resposta.data.exception.errorMessage);
    } else {
      atendimento = resposta.data;
      return resposta.data.message ? resposta.data.message : resposta.data;
    }
  } else {
    return atendimento;
  }
};


export default { Suporte, ERP, ProcessosEProjetos, Gerencia, Labs, Operacao, Sistemas, Seguranca, Atendimento};
